<h1 class="font-heading text-center text-4xl font-medium text-white select-none">
  {{ text() }}
</h1>
